export const lightTheme = {
    body: '#E2E2E2',
    container: '#f2f2f2',
    text: '#363537',
    toggleBorder: '#FFF',
    gradient: 'linear-gradient(#39598A, #79D7ED)',
    inputColor: '#f8f9fa',
}

export const darkTheme = {
    body: '#363537',
    container: '#474b54',
    text: '#FAFAFA',
    toggleBorder: '#6B8096',
    gradient: 'linear-gradient(#091236, #1E215D)',
    inputColor: '#4f5461',
}